import { Injectable } from '@angular/core';

// TODO: раскидать на константы
// @dynamic
@Injectable({
  providedIn: 'root'
})
export class HxDataService {
  static pagination = {
    currentPage: 1,
    allItemCount: 0,
    limit: 20,
    maxPage: 1
  };
  static entity = ['INDIVIDUAL', 'LEGAL'];

  constructor() {
  }
}
